import moment from 'moment';


export default function BcpBoardApproveDialogController(
  $rootScope,
  $scope,
  $q,
  alerts,
  ssDialogService,
  bcpDataService,
  loaderService,
  reportsDataService
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleSaveBoardApprove = _handleSaveBoardApprove;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    vm.approvedById = -1;
    vm.boardApprovedMinDate = moment().add(-18, 'months');
    vm.boardApprovedCurrentDate = moment().add(0, 'days');
    vm.boardApprovedMaxDate = vm.boardApprovedCurrentDate;
    vm.boardApprovedDate = vm.boardApprovedCurrentDate.format('MM/DD/YYYY');
    vm.confirmSubmit = false;
  }

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.bcp.boardApproveDialog);
  }

  function _handleSaveBoardApprove() {
    if ($scope.bcpBoardApproveForm.$invalid) {
      return;
    }
    vm.boardApprovedDate = vm.boardApprovedCurrentDate.format('MM/DD/YYYY');
    bcpDataService.approveAssessment(vm.assessmentId, vm.approvedById, vm.boardApprovedDate).then((response) => {
      if (!response.data.result) {
        alerts.error('Error occurred while saving Board Approval.');
      } else {
        alerts.success('The BCP Plan was successfully Board Approved.');
        alerts.info('Please Wait! Updating document with Approved date. This may take a while');

        let sections = '1,2,3,4,5';
        if (vm.includePandemicPolicy) { sections += ',6'; }
        if (vm.includeEmergencyPlan) { sections += ',7'; }
        if (vm.includeKeyContacts) { sections += ',8'; }
        if (vm.includeSchematics) { sections += ',9'; }

        loaderService.showViewLoader = true;
        const downloadCall = bcpDataService.generateFullReport(
          {
            assessmentId: vm.assessmentId,
            name: vm.assessmentName,
            reportSection: sections,
            renderFullReport: true,
            saveDocument: true,
          },
        );

        downloadCall.then((r) => {
          alerts.success('The BCP assessment document is updated successfully.');
          loaderService.showViewLoader = false;
          reportsDataService.download(r);
          $rootScope.$broadcast('refreshBCPAssessments');
        });

        ssDialogService.hide(ssDialogService.dialogs.bcp.boardApproveDialog);
      }
    });
  }
}

BcpBoardApproveDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'alerts',
  'ssDialogService',
  'bcpDataService',
  'loaderService',
  'reportsDataService'
];
